import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from './button';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggler: React.FC = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <Button variant="outline" size="icon" onClick={toggleTheme} className="dark:border-slate-200 w-8 h-8 sm:w-10 sm:h-10">
      <Sun className="h-4 w-4 sm:h-[1.2rem] sm:w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 dark:text-slate-200" />
      <Moon className="absolute h-4 w-4 sm:h-[1.2rem] sm:w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 dark:text-slate-200" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};